export default {
  Auth: {
    // REQUIRED - Amazon Cognito Identity Pool ID
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL || 'us-east-1:e258cc90-3d1c-4234-8d3a-918b4b9cd9ad',
    // REQUIRED - Amazon Cognito Region
    region: process.env.REACT_APP_COGNITO_REGION || 'us-east-1',
    // OPTIONAL - Amazon Cognito User Pool ID
    userPoolId: process.env.REACT_APP_COGNITO_POOL || 'us-east-1_zXoWFwRLa',
    // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT || '1kgsur8ogmn93f25efh5u2v30u',
    // OPTIONAL - Enforce user authentication prior to accessing AWS resources or not
    // mandatorySignIn: false,
    // OPTIONAL - Configuration for cookie storage
    // cookieStorage: {
    //   // REQUIRED - Cookie domain (only required if cookieStorage is provided)
    //   domain: '.yourdomain.com',
    //   // OPTIONAL - Cookie path
    //   path: '/',
    //   // OPTIONAL - Cookie expiration in days
    //   expires: 365,
    //   // OPTIONAL - Cookie secure flag
    //   secure: true
    // }
  },
  API: {
    endpoints: [
      {
        name: 'GreenleafApi',
        endpoint: process.env.REACT_APP_API_URL || 'http://localhost:5001'
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/auth-config.js